import { AccountPutSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import AccountDDISelect from "Components/Shared/AccountDDISelect";
import FormSubmit from "Components/Shared/FormSubmit";
import OrganisationSelect from "Components/Shared/OrganisationSelect";
import { Field, Formik } from "formik";
import React from "react";
import { Container, Divider, Form, Header } from "semantic-ui-react";

type GeneralFormProps = {
  account: Account;
  update: Function;
  validateName: Function;
  validateDomain: Function;
};

function GeneralForm({
  account,
  update,
  validateName,
  validateDomain,
}: GeneralFormProps) {
  return (
    <Container textAlign='left'>
      <Header as='h3'>General</Header>
      <Divider />
      <Formik
        initialValues={account}
        validationSchema={AccountPutSchema}
        onSubmit={(values, actions) => {
          update(values);
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Field
              name='id'
              label='ID'
              disabled={true}
              component={CallableInput}
            />

            <Field
              name='clientID'
              label='Client ID'
              disabled={true}
              component={CallableInput}
            />

            <OrganisationSelect name='organisation' label='Organisation' />

            <Field
              name='name'
              label='Name'
              validate={validateName}
              component={CallableInput}
            />

            <Field
              name='domain'
              label='Domain'
              validate={validateDomain}
              component={CallableInput}
            />

            <AccountDDISelect
              name='mbn'
              label='Main Billing Number'
              account={account}
            />

            <FormSubmit name='Update Account' errors={props.errors} />
          </Form>
        )}
      </Formik>
    </Container>
  );
}

export default GeneralForm;
